import {SystemStyleObject} from '@chakra-ui/react';

const THUMB = 'var(--chakra-colors-white-alpha-400)';
const THUMB_HOVER = 'var(--chakra-colors-white-alpha-600)';

/**
 * A slim, rounded scrollbar for dark panels (the viewer's sidebars): a light thumb on a clear track,
 * brighter while hovered. Pass as `css`. The standard properties serve Firefox and Chrome (which then
 * ignores the `::-webkit-scrollbar` rules), those rules Safari.
 */
export const slimScrollbar: SystemStyleObject = {
    scrollbarWidth: 'thin',
    scrollbarColor: `${THUMB} transparent`,
    '&:hover': {scrollbarColor: `${THUMB_HOVER} transparent`},
    '&::-webkit-scrollbar': {width: '6px', height: '6px'},
    '&::-webkit-scrollbar-track': {background: 'transparent'},
    '&::-webkit-scrollbar-thumb': {background: THUMB, borderRadius: '9999px'},
    '&::-webkit-scrollbar-thumb:hover': {background: THUMB_HOVER},
};
